(function () {
    "use strict";

    angular.module("sempraWebapp").controller("RolloverSalesTypesController", RolloverSalesTypesController);

    /** @ngInject */
    function RolloverSalesTypesController(
        $scope,
        $state,
        $translate,
        $mdDialog,
        dashboardKarcherActions,
        dialogsService
    ) {
        var vm = this;

        vm.salesTypes = [];
        vm.isLoading = true;

        vm.goBack = goBack;
        vm.openEditDialog = openEditDialog;

        init();

        function init() {
            loadSalesTypes();
        }

        function loadSalesTypes() {
            vm.isLoading = true;
            dashboardKarcherActions.getAllRolloverSalesTypes().then(
                function (response) {
                    vm.salesTypes = response || [];
                    vm.isLoading = false;
                },
                function () {
                    vm.salesTypes = [];
                    vm.isLoading = false;
                    dialogsService.showErrorDialog(
                        $translate.instant('ERROR_TITLE'),
                        $translate.instant('ERROR_MESSAGE')
                    );
                }
            );
        }

        function goBack() {
            window.history.back();
        }

        function openEditDialog(salesType) {
            $mdDialog.show({
                controller: EditSalesTypeDialogController,
                controllerAs: 'dialog',
                templateUrl: 'app/rollover/editSalesTypeDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: true,
                locals: {
                    salesType: salesType
                }
            }).then(function (updatedSalesType) {
                if (updatedSalesType) {
                    var index = vm.salesTypes.findIndex(function(st) { return st.id === updatedSalesType.id; });
                    if (index !== -1) {
                        vm.salesTypes[index] = updatedSalesType;
                    }
                }
            });
        }

        /** @ngInject */
        function EditSalesTypeDialogController($mdDialog, salesType, dashboardKarcherActions, dialogsService, $translate) {
            var dialog = this;
            
            dialog.salesType = salesType;
            dialog.editData = {
                description: salesType.description || '',
                active: salesType.active === true
            };
            dialog.isSaving = false;
            
            dialog.cancel = function() {
                $mdDialog.cancel();
            };
            
            dialog.save = function() {
                dialog.isSaving = true;
                
                var updateData = {
                    id: salesType.id,
                    description: dialog.editData.description,
                    active: dialog.editData.active
                };
                
                dashboardKarcherActions.updateRolloverSalesType(updateData).then(
                    function (response) {
                        dialog.isSaving = false;
                        salesType.description = updateData.description;
                        salesType.active = updateData.active;
                        
                        $mdDialog.hide(salesType);
                    },
                    function () {
                        dialog.isSaving = false;
                        dialogsService.showErrorDialog(
                            $translate.instant('ERROR_TITLE'),
                            $translate.instant('ERROR_MESSAGE')
                        );
                    }
                );
            };
        }
    }
})();
